import React, {useEffect, useState, Fragment} from 'react';
import CategoryItem from './CategoryItem'
//import CategoryContents from '../CategoryContents'
import ProductCard from '../ProductCard'
import flatstore from 'flatstore';
import {getProducts, getMenu} from '../../../utils/services';
import { isNull, isNil } from 'lodash';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import { currentLang } from '../../../utils/functions';

const Category = ({animal_data, products_data, filter, config}) => {
    const [categories, setCategories] = useState(null);
    const [products, setProducts] = useState(null);
    const [activeCategory, setActiveCategory] = useState(null);
    const [items, setItems] = useState(null);
    const { t } = useTranslation();
    const [pageLoad, setPageLoad] = useState(0);
    const {pathname} = useLocation();
    const [mobileActiveScroll, setMobileActiveScroll] = useState(false); // active animal switch scroll on mobile

    const location = useLocation();
    const path = location.pathname.split('/').filter(str=>str.length>1);

    
    useEffect(() => {
        animal_data = null;
        products_data = null;
    }, [])

    useEffect(() => {
        //console.log(animal_data);
        if(isNil(animal_data)){
            getMenu('animals', 'animal_data');
            getProducts();
        }

        if(!isNil(animal_data) && isNil(categories)){
            setCategories(animal_data);
        }

    }, [animal_data]);

    useEffect(() => {
        
        if(!isNil(products_data)){
            setProducts(products_data);
            if(categories){
                if(activeCategory){
                    handleClick(activeCategory);
                }else{
                    var clicked = false;
                    categories.map((item)=>{
                        if(filter){
                            if(t(filter) == item.url){
                                clicked = true;
                                handleClick(item.menu_item_id);
                            }
                        }else{
                            if(config && !isNil(config.selected_item)){
                                clicked = true;
                                handleClick(parseInt(config.selected_item));
                            }
                        }
                    })
                    if(!clicked){
                        //console.log(categories[Math.ceil(categories.length/2)-1].menu_item_id);
                        //handleClick(categories[Math.ceil(categories.length/2)-1].menu_item_id);
                    }
                }
            }
        }
        // activate the scroll on mobile after products data load
        if(!isNil(path[2]) && path.includes(t('menu.animal'))){
            setMobileActiveScroll(true);
        }

    }, [products_data, categories]);

    useEffect(() => {

        if(products_data){

            if(categories){
                var clicked = false;
                categories.map((item)=>{
                    if(filter){
                        if(t(filter) == item.url){
                            clicked = true;
                            handleClick(item.menu_item_id);
                        }
                    }else{
                        if(config && !isNil(config.selected_item)){
                            clicked = true;
                            handleClick(parseInt(config.selected_item));
                        }
                    }
                })
                if(!clicked){
                    //handleClick(categories[Math.ceil(categories.length/2)-1].menu_item_id);
                }
            }
        }
    }, [filter])



    useEffect(() => {

        if(activeCategory && pathname !== '/'+currentLang() && pathname !== '/'+currentLang()+'/'){
            var activeItem = document.querySelector('.category__item.active');
            if(activeItem){
                /* 
                    I don't know why we have the pageLoad for mobile. 
                    Maybe because of the rerender and another scroll after we change the category (+url change)
                */
                if(window.innerWidth <= 768 && mobileActiveScroll){
                    if(pageLoad == 0 && !filter){
                        if(!isNil(activeItem)){
                            
                            activeItem.scrollIntoView({
                                behavior: "smooth",
                                block: "end",
                                inline: "center",
                                alignToTop: true
                            });
                            setPageLoad(1);
                        }
                    }else{
                        if(!isNil(activeItem)){
                            activeItem.scrollIntoView({
                                behavior: "smooth",
                                inline: "center",
                                alignToTop: true
                            });
                        }
                    }
                }
            }

        }
    }, [activeCategory])

    const handleClick = (value) =>{

        if(activeCategory !== value){
            setActiveCategory(value);

            let categoryItems = [];

            categories.map((item)=>{
                if(item.parent_id == value)
                    categoryItems.push(item);
            })
            setItems(categoryItems);
        }

    }

    // fix the rerender problem 
    const checkProductCategory = (product_slug) =>{
        var arr = false;
        items.map(item => {
            if(item.product_slug == product_slug){
                arr = true;
            }
        })
        return arr;
    }

    return (
        <Fragment>
            {items &&
            <Fragment>
            <section className="category">
                {categories && categories.map((item, index) => {
                        if(config && config.disabled_items && config.disabled_items.includes(item.menu_item_id.toString())){
                            item.parent_id = 1; // kalak rashti
                        }
                        if(!item.parent_id){
                            return (
                                <CategoryItem
                                    id={item.menu_item_id}
                                    name={item.title}
                                    icon={item.icon_class}
                                    slug={item.product_slug}
                                    number={categories.reduce((a, b) => a + (b['parent_id'] == item.menu_item_id || 0), 0)}
                                    parentCallback={handleClick}
                                    defaultCategory={(config && config.selected_item) ? parseInt(config.selected_item) : null}
                                    activeCategory={activeCategory}
                                    filter={item.url}
                                />
                            )
                        }
                })}
            </section>
            <section className="category__holder">
                <div className="container-fluid">
                    <div className="row">
                      <div className="col-12 col-lg-12 col-xxl-10">
                        <div className="row">
                          {products && products.map((item, index) => {
                                if(checkProductCategory(item.slug)){
                                  return (
                                    <div className="col-sm-6 col-md-6 col-xl-3">
                                      <ProductCard key={index} data={item} />
                                    </div>
                                  )
                                }
                          })}
                        </div>
                      </div>
                    </div>
                </div>
            </section>
            </Fragment>
            }
        </Fragment>
    )
}

export default flatstore.connect(['animal_data', 'products_data'])(Category);
